// extracted by mini-css-extract-plugin
export default {"list":"style_list__M3aWk","tab":"style_tab__1JnGM","activeTab":"style_activeTab__zcPIF"};